import React, { useEffect } from 'react';
import { ErrorBoundary as ImportedErrorBoundary } from 'react-error-boundary';
import AppErrorBoundaryTemplate from './errorPage';

export default function ErrorBoundary({ children }) {
  useEffect(() => {
    window.onerror = function (message, file, line, col, stack) {
      // create interaction
      console.error(message, file, line, col, stack?.stack);
    };
  }, []);
  const handleReset = () => {
    window.location.reload();
  };
  const handleError = (error) => {};
  const errorFallback = ({ error, resetErrorBoundary }) => (
    <AppErrorBoundaryTemplate
      error={error}
      resetErrorBoundary={resetErrorBoundary}
    />
  );

  return (
    // TODO: Scrub error!
    <ImportedErrorBoundary
      FallbackComponent={errorFallback}
      onError={handleError}
      onReset={handleReset}
    >
      {children}
    </ImportedErrorBoundary>
  );
}
